import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AIFileTagsSuggestions, AITagManagementTitle } from './components';

export interface AITagManagementProps {
  onChangeTags: (newTags: string[], fileId: string) => void;
  fileId: string;
  tags: TagOption[];
  aiIngestionStatus?: string;
}

export const AITagManagement = ({
  onChangeTags,
  fileId,
  tags,
  aiIngestionStatus,
}: AITagManagementProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded((currentStatus) => !currentStatus)}
      elevation={0}
      square
      disableGutters
      className="ai-tag-management"
      data-tour="ai-tag-management"
      sx={{
        border: 'none',
        borderBottom: 'none',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="ai-file-management-content"
        id="ai-file-management-header"
        sx={{
          padding: 0,
          minHeight: 'auto',
          borderBottom: 'none',
          cursor: 'pointer',
          '&.MuiButtonBase-root-MuiAccordionSummary-root': {
            borderBottom: 'none',
          },
        }}
      >
        <AITagManagementTitle />
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: 0,
        }}
      >
        <AIFileTagsSuggestions
          onChangeTags={onChangeTags}
          fileId={fileId}
          isVisible={expanded}
          initialTags={tags}
          aiIngestionStatus={aiIngestionStatus}
        />
      </AccordionDetails>
    </Accordion>
  );
};
